import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import rules from '../../../common/rules/rules';

const { Item: FormItem } = Form;

@translate()
@Form.create()
export default class InterestSettingsForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    interestSettings: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit, interestSettings } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        const newInterestSettings = interestSettings.map(s => ({ ...s }));

        newInterestSettings.forEach(range => {
          range.allocationInterestMax = values[range.id].allocationInterestMax;
          range.loanInterest = values[range.id].loanInterest;
        });

        onSubmit(newInterestSettings);
      }
    });
  };

  render() {
    const { form, t, interestSettings, isUpdating } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Spin spinning={isUpdating}>
        <h2 style={{ marginTop: 20 }}>{t('Úroky')}</h2>

        <Form onSubmit={this.handleSubmit} hideRequiredMark>
          {interestSettings.map(range => (
            <div key={range.id}>
              <h3 style={{ marginTop: 20 }}>
                {range.termMonthsMin} - {range.termMonthsMax} {t('mesiacov')}
              </h3>
              <Row>
                <Col xs={12} md={6}>
                  <FormItem label={t('Úroková miera investor')}>
                    {getFieldDecorator(`${range.id}.allocationInterestMax`, {
                      rules: rules.required,
                      initialValue: range.allocationInterestMax,
                    })(<Input size="default" />)}
                  </FormItem>
                </Col>
                <Col xs={12} md={6}>
                  <FormItem label={t('Úroková miera dlžník')}>
                    {getFieldDecorator(`${range.id}.loanInterest`, {
                      rules: rules.required,
                      initialValue: range.loanInterest,
                    })(<Input size="default" />)}
                  </FormItem>
                </Col>
              </Row>
            </div>
          ))}

          <Form.Item style={{ marginTop: 20 }}>
            <Button size="default" type="primary" htmlType="submit">
              {t('Uložiť')}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/setting-management/components/InterestSettingsForm.js